import $ from 'jquery'

import ToolUI from './ui/Tool'

/**
 * Tool class
 * @param {Object} config
 * @param {boolean=} config.enableToggle True to enable pressed/not
 *     pressed toggling. Defaults to false.
 * @constructor
 */
export default class Tool {
  constructor(config) {
    this.activated = false
    this.enableToggle = true

    $.extend(this, config || {})

    this.ui = new ToolUI(config)
  }

  activate() {
    if (this.interaction) this.map.addInteraction(this.interaction)
    this.ui.activate()
    this.activated = true
  }

  deactivate() {
    if (this.interaction) this.map.removeInteraction(this.interaction)
    this.ui.deactivate()
    this.activated = false
  }
}

Tool.prototype.activated = false
Tool.prototype.enableToggle = true
